var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "389.000000pt",
    height: "170.000000pt",
    viewBox: "0 0 389.000000 170.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,170.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572 983 c3 -454 4 -470 25 -521 44 -109 136 -193 247 -228 66 -21 254 -29 331 -15 137 26 244 103 295 214 44 95 51 184 48 622 l-3 390 -137 3 -137 3 -3 -413 -3 -413 -25 -50 c-35 -69 -74 -90 -170 -90 -124 0 -171 45 -191 178 -5 34 -9 225 -9 425 l0 362 -135 0 -136 0 3 -467z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889 1423 c-6 -16 -114 -284 -241 -598 -126 -314 -232 -576 -235 -583 -4 -9 29 -12 145 -12 l149 0 44 120 44 120 234 -2 233 -3 43 -115 43 -115 150 -3 150 -3 -165 408 c-90 225 -201 499 -246 611 l-81 202 -128 0 -128 0 -11 -27z m206 -523 c32 -85 60 -161 63 -167 3 -10 -27 -13 -131 -13 l-134 0 66 174 c36 96 69 171 72 168 3 -4 32 -77 64 -162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1325 l0 -125 145 0 145 0 0 -485 0 -485 140 0 140 0 0 485 0 484 143 3 142 3 0 120 0 120 -427 3 -428 2 0 -125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUat);
export default __webpack_public_path__ + "static/media/UAT.a782331f6e0d899007518a5687702f6b.svg";
export { ForwardRef as ReactComponent };